import { render, staticRenderFns } from "./StandingsRoundListSection.vue?vue&type=template&id=36f3ba1b&scoped=true"
import script from "./StandingsRoundListSection.vue?vue&type=script&lang=ts"
export * from "./StandingsRoundListSection.vue?vue&type=script&lang=ts"
import style0 from "./StandingsRoundListSection.vue?vue&type=style&index=0&id=36f3ba1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f3ba1b",
  null
  
)

export default component.exports